
import React from 'react';

import { Link } from 'react-router-dom';

function DeclarationPage() {
  return (
    <>

      <div className="bg-[#F9FAFB] min-h-screen font-sans">
        <div className="bg-white border-b border-gray-200">
          <div className="max-w-4xl mx-auto px-6 py-12">
            <span className="inline-block py-1 px-3 rounded-sm bg-[#2F80ED] text-white text-xs font-bold tracking-wide uppercase mb-4">
              AASC Accountability Declaration
            </span>
            <h1 className="text-3xl font-bold text-[#102A43] mb-4">Accountability Declaration</h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              A verifiable public commitment to baseline operational principles.
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-6 py-12 space-y-12">
          <section className="bg-white p-8 rounded-sm shadow-sm border border-gray-200">
            <h2 className="text-xl font-bold text-[#102A43] mb-4 border-b border-gray-100 pb-2">What This Is</h2>
            <p className="text-[#64748B] mb-4">
              The Accountability Declaration is a self-attested mechanism for organizations using AI to signal professional intent. It constitutes a formal public statement that the organization understands AASC baseline principles for accountability and human oversight and commits to applying them.
            </p>
          </section>

          <section className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-sm shadow-sm border border-gray-200">
              <h2 className="text-xl font-bold text-[#102A43] mb-4">Annual Program Fee</h2>
              <div className="flex items-baseline mb-2">
                <span className="text-4xl font-bold text-[#102A43]">$997</span>
                <span className="text-gray-600 ml-2">/ year</span>
              </div>
              <p className="text-sm text-gray-500">
                Includes registry maintenance, verification services, and declaration badge usage rights.
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-sm shadow-sm border border-gray-200">
              <h2 className="text-xl font-bold text-[#102A43] mb-4">Who This Is For</h2>
              <ul className="space-y-2 text-[#64748B]">
                <li className="flex gap-2"><span className="text-[#2F80ED] font-bold">•</span> Any Organization Using AI</li>
                <li className="flex gap-2"><span className="text-[#2F80ED] font-bold">•</span> Systems Integrators</li>
                <li className="flex gap-2"><span className="text-[#2F80ED] font-bold">•</span> Managed Service Providers</li>
                <li className="flex gap-2"><span className="text-[#2F80ED] font-bold">•</span> Independent Consultants</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-6">What You Declare</h2>
            <div className="bg-gray-100 p-6 border-l-4 border-gray-400">
              <p className="text-gray-800 font-medium italic mb-4">
                "I hereby declare that I have reviewed the AASC Standards for Human Authority and Outcome Accountability. I commit to applying these principles in my professional practice. I acknowledge that I am solely responsible for the outcomes of the systems I configure or deploy."
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4">What's Included</h2>
            <ul className="list-disc pl-5 space-y-2 text-[#64748B]">
              <li><strong>Public Directory Listing:</strong> Approved organizations are listed in the Public Registry.</li>
              <li><strong>Badge Usage Rights:</strong> Receive the "Accountability Declared" digital badge.</li>
              <li><strong>Verification Status Page:</strong> A dedicated page verifying your active status.</li>
              <li><strong>Annual Renewal:</strong> Maintain your status through yearly self-attestation.</li>
            </ul>
            <div className="bg-red-50 p-4 border border-red-100 text-sm text-red-900 mt-4">
              <strong>Usage Restriction:</strong> Declared organizations may NOT use terms such as "Declared," "Audited," or "Verified Partner." Misuse of the Declaration badge will result in immediate revocation.
            </div>
          </section>

          <div className="pt-8 text-center">
            <Link to="/apply" className="inline-block px-8 py-4 bg-[#2F80ED] text-white font-bold rounded-sm hover:bg-[#2563eb] transition-colors">
              Start Your Declaration
            </Link>
          </div>

        </div>
      </div>
    </>
  );
}

export default DeclarationPage;
